import { setActivityFromValue, setTreatsFromValue, setWeightFromValue } from "./range.js";

const handleChange = (event, data) => {
  const { type, value } = event.target;
  const attribute = event.target.getAttribute("data-order");

  if (attribute === "size") {
    data[attribute]["answer"] = setWeightFromValue(value);

  } else if (attribute === "activity") {
    data[attribute]["answer"] = setActivityFromValue(value);

  } else if (attribute === "treats") {
    data[attribute]["answer"] = setTreatsFromValue(value);

  } else if (type.match(/^(text|radio|email|number|range)$/)) {
    data[attribute]["answer"] = value;

  } else if (type === "checkbox") {
    if (value === "Nothing") {
      data[attribute]["answer"] = [value];
    } else {
      if (data[attribute]["answer"].indexOf(value) != -1) {
        data[attribute]["answer"].splice(data[attribute]["answer"].indexOf(value), 1);
      } else {
        data[attribute]["answer"].push(value);
      }
      data[attribute]["answer"] = data[attribute]["answer"].filter(item => item !== "Nothing");
    }

  }

};

export default handleChange
